import React from "react";

const Heading = ({ title }) => {
  return (
    <>
      <h1 className="text-4xl font-bold">{title}</h1>
    </>
  );
};

export default Heading;
